import React, { useContext, useEffect } from "react";
import { NetworkRedirectContainer } from "./NetworkRedirectStyled";
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { UserContext } from "../../context/userContext";
import { getAccessTokenYoutube, getMyFollowersNetworks, validateStateYoutube } from "../../api/networksApi";
import { useState } from "react";
import Spinner from "../../components/Spinner/Spinner";
import Alert from "../../components/Alert/Alert";
import Lottie from 'react-lottie';
import * as animationData from './youtube-logo-effect.json';

export default function YoutubeRedirect() {

    const navigate = useNavigate();

    const { userType, userToken, id, setYoutubeSuscribers } = useContext(UserContext);

    //const [isLoading, setIsLoading] = useState(true);
    const [isStopped, setIsStopped] = useState(false);
    const [isPaused, setIsPaused] = useState(false);

    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);

    //Accedemos a los valores
    let code = urlParams.get('code');
    let scopes = urlParams.get('scopes');
    let state = urlParams.get('state');

    const [showAlertError, setShowAlertError] = useState(false);



    useEffect(() => {

        if (userType !== '' && id !== null) {

            validateStateYoutube({ typeUser: userType, token: userToken, state }).then((response) => {

                if (response.message === true) {

                    getAccessTokenYoutube({ typeUser: userType, token: userToken, code }).then((response) => {

                        if (response.access_token) {

                            getMyFollowersNetworks({ userId: id, typeUser: userType }).then((response) => {

                                setYoutubeSuscribers(response[0].followers.youtube)
                                //setIsLoading(false);
                                setIsStopped(true);
                                navigate('/myprofile');
                            })

                        } else {
                            //setIsLoading(false);
                            setIsStopped(true);
                            setShowAlertError(true);
                        }
                    })
                } else {
                    //setIsLoading(false);
                    setIsStopped(true);
                    setShowAlertError(true);
                }
            })
        }
    }, [state, userType, id])

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <NetworkRedirectContainer>

            <Lottie options={defaultOptions}
                height={200}
                width={200}
                isStopped={isStopped}
                isPaused={isPaused} />

            {/* <p>Redirect youtube page</p> */}

            {/*  {(isLoading) && (<Spinner />)} */}

            {(showAlertError) && (<Alert
                title={<FormattedMessage id="alert_error_network_title" defaultMessage="Error" />}
                text={<FormattedMessage id="alert_error_youtube_text" defaultMessage="No pudimos conectar su cuenta de youtube, por favor intente mas tarde." />}
                setShowAlert={setShowAlertError}
                confirmText={<FormattedMessage id="alert_error_network_button" defaultMessage="Ir a mi perfil" />}
                onConfirm={() => { navigate('/myprofile') }}
            />)}

        </NetworkRedirectContainer>

    )
}